import { render, staticRenderFns } from "./OrderFormBox.vue?vue&type=template&id=afdf642a&scoped=true"
import script from "./OrderFormBox.vue?vue&type=script&lang=js"
export * from "./OrderFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OrderFormBox.vue?vue&type=style&index=1&id=afdf642a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdf642a",
  null
  
)

export default component.exports